export default "__VITE_ASSET__$AXWQ5KK__"